const mockDestination = [
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab',
    description: 'Chamonix, is a beautiful city, a true asian pearl, with crowded streets.',
    name: 'Chamonix',
    pictures: [
      {
        'src': 'http://picsum.photos/300/200?r=0.0762563005163317',
        'description': 'Chamonix parliament building'
      }
    ]
  },
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab-001',
    description: 'Barcelona is a city on the northeastern coast of Spain. It is the capital and largest city of the autonomous community of Catalonia, as well as the second-most populous municipality of Spain.',
    name: 'Barselona',
    pictures: [
      {
        'src': 'http://picsum.photos/300/200?r=0.0762563005163317',
        'description': 'Barselona Sagrada Familia'
      }
    ]
  },
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab-002',
    description: 'Milan is a city in northern Italy, regional capital of Lombardy, the largest city in Italy by urban population and the second-most-populous city proper in Italy after Rome.',
    name: 'Milan',
    pictures: [
      {
        'src': 'http://picsum.photos/300/200?r=0.0762563005163317',
        'description': 'Duomo di Milano'
      }
    ]
  },
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab-003',
    name: 'Paris',
    description: 'Paris is the capital of France, known for its art, fashion, and landmarks such as the Eiffel Tower and the Louvre.',
    images: [
      'https://upload.wikimedia.org/wikipedia/commons/e/e6/Paris_Night.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/6/6d/Eiffel_Tower_Paris.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/3/3e/Louvre_Museum_Wikimedia_Commons.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/5/5d/Chateau_de_Chambord.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/4/4d/Mont_Saint_Michel_France.jpg'
    ]
  },
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab-004',
    name: 'Tokyo',
    description: 'Tokyo is the bustling capital of Japan, famous for its skyscrapers, cherry blossoms, and vibrant culture.',
    images: [
      'https://upload.wikimedia.org/wikipedia/commons/0/0c/Tokyo_Tower_and_around_Skyscrapers.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/9/9e/Kyoto_Fushimi_Inari_Taisha.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/7/7e/Mount_Fuji_from_Lake_Kawaguchi.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/5/5e/Himeji_Castle.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/3/3c/Osaka_Castle.jpg'
    ]
  },
  {
    id: 'cfe416cq-10xa-ye10-8077-2fs9a01edcab-005',
    name: 'Sydney',
    description: 'Sydney is a major city in Australia, known for its iconic Opera House, Harbour Bridge, and beautiful beaches.',
    images: [
      'https://upload.wikimedia.org/wikipedia/commons/8/84/Sydney_Opera_House.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/1/1e/Great_Barrier_Reef.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/6/6e/Uluru_Australia.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/3/3e/Kangaroo_Australia.jpg',
      'https://upload.wikimedia.org/wikipedia/commons/4/4e/Twelve_Apostles_Australia.jpg'
    ]
  }
];


export {mockDestination};
